<script>
import CampaignTypes from 'dashboard/components/widgets/CampaignTypes.vue';
import router from 'dashboard/routes/index';
import PageHeader from 'dashboard/routes/dashboard/settings/SettingsSubPageHeader.vue';
import { mapGetters } from 'vuex';
import globalConfigMixin from 'shared/mixins/globalConfigMixin';

export default {
  components: {
    CampaignTypes,
    PageHeader,
  },
  mixins: [globalConfigMixin],
  props: {
    templateName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      enabledFeatures: {},
      // Defina aqui quais campanhas devem estar ativas para este componente
      activeCampaigns: ['database', 'google_drive'], // Adicione ou remova conforme necessário
    };
  },
  computed: {
    account() {
      return this.$store.getters['accounts/getAccount'](this.accountId);
    },
    campaignList() {
      return [
        { key: 'database', name: 'Banco de Dados' },
        { key: 'tag', name: 'Etiquetas' },
        { key: 'google_drive', name: 'Google Drive' },
      ];
    },
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      globalConfig: 'globalConfig/get',
    }),
  },
  mounted() {
    this.initializeEnabledFeatures();
  },
  methods: {
    async initializeEnabledFeatures() {
      this.enabledFeatures = this.account.features;
    },
    initCampaignSetup(campaign) {
      const routeName =
        campaign === 'google_drive'
          ? 'campaigns_whatsapp_official_configure_google_sheets'
          : 'campaigns_whatsapp_official_configure_list';

      router.push({
        name: routeName,
        params: { accountId: this.accountId, sub_page: campaign },
        query: { templateName: this.templateName },
      });
    },
  },
};
</script>

<template>
  <div
    class="border border-woot-400 dark:border-woot-400 bg-n-background min-h-[100px] p-6 w-full max-w-full md:w-3/4 md:max-w-[75%] flex-shrink-0 flex-grow-0"
  >
    <PageHeader
      class="max-w-4xl"
      :header-title="$t('CAMPAIGN.WHATSAPP_OFFICIAL.ADD_CAMPAIGN.TITLE')"
      :header-content="$t('CAMPAIGN.WHATSAPP_OFFICIAL.ADD_CAMPAIGN.BODY')"
    />
    <div
      class="grid max-w-3xl grid-cols-2 mx-0 mt-6 sm:grid-cols-3 lg:grid-cols-4"
    >
      <CampaignTypes
        v-for="campaign in campaignList"
        :key="campaign.key"
        :campaign="campaign"
        :enabled-features="enabledFeatures"
        :active-campaigns="activeCampaigns"
        @campaign-item-click="initCampaignSetup"
      />
    </div>
  </div>
</template>